<div [hidden]="this.loading">
  <div *ngIf="!this.error">
    <!-- Player -->
    <div id="playerDiv" style="position:relative; left:0px; top:0px;"></div>

    <div *ngIf="this.playlist">
      <!--  Playlist -->
      <ul [id]="'playlists' + this.playlist.PlaylistId" style="display:none;">
        <li
          [attr.data-source]="'playlist' + this.playlist.PlaylistId"
          [attr.data-playlist-name]="this.playlist.PlaylistTitle"
          data-thumbnail-path=""
        ></li>
      </ul>

      <!--  Videos -->
      <ul [id]="'playlist' + this.playlist.PlaylistId" style="display:none;">
        <li
          *ngFor="let video of this.playlist.PlaylistVideos; let i = index;"
          [attr.data-thumb-source]="video.VideoThumbnailUrl"
          [attr.data-video-source]="this.generateVideoURL(video)"
          data-downloadable="no"
          data-vast-url="https://bigcheese-public-shared.s3.amazonaws.com/Tenfield/Player/Ads/VASTs/VMAP_Test_2.xml"
        >
          <!--
            Archivo: Google (Test)
            Videos: Google (Test)
              data-vast-url="https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/single_ad_samples&sz=640x480&cust_params=sample_ct%3Dlinear&ciu_szs=300x250%2C728x90&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator="
            Archivo: Local
            Videos: Google (Test)
              data-vast-url="../../../assets/vast/VMAP_Test_0.xml"
            Archivo: Local
            Videos: S3
              data-vast-url="../../../assets/vast/VMAP_Test_1.xml"
            Archivo: S3
            Videos: Google
              data-vast-url="https://bigcheese-public-shared.s3.amazonaws.com/Tenfield/Player/Ads/VASTs/VMAP_Test_2.xml"
            Archivo: S3
            Videos: S3
              data-vast-url="https://bigcheese-public-shared.s3.amazonaws.com/Tenfield/Player/Ads/VASTs/VMAP_Test_3.xml"
          -->
          <!--
          Para probar la publicidad
          [attr.data-vast-url]=" i === 0 || i === 1 ? '../../../assets/vast/VMAP_Test_' + i + '.xml' : null"
          -->
          <div data-video-short-description="">
            <div>
              <p class="fwduvp-thumbnail-title">{{video.VideoTitle}}</p>
            </div>
          </div>
        </li>

        <!-- ToDo: Agregar el <li>, es un video harcodeado con source directo a un m3u8 para probar el tema con iOS. -->
        <!--<li
          [attr.data-thumb-source]="'https://tenfield-highlights-test.s3.amazonaws.com/imagenes/625b5c1c5b19593a83ab5af5.jpg'"
          [attr.data-video-source]="'https://d3gqy3tjdlnt8s.cloudfront.net/82e41896-ecfd-4512-947f-5b28c08f0b68/hls/6251f0aa92f35642e736cb9b.m3u8'"
          data-downloadable="no"
        >
          <div data-video-short-description="">
            <div>
              <p class="fwduvp-thumbnail-title">Video m3u8</p>
            </div>
          </div>
        </li>-->

      </ul>
    </div>
  </div>

  <div *ngIf="this.error" class="container">
    <div *ngIf="this.error" [innerHTML]="this.error" class="errors-container mt-3 alert alert-danger" role="alert"></div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <app-sign-in-form
          *ngIf="this.screenInPopUp === 'SIGN_IN'"
          [message]="this.messageToScreen"
          [isInPopup]="true"
          (changeScreen)="this.changeScreen($event)"
        ></app-sign-in-form>
        <app-sign-up-form
          *ngIf="this.screenInPopUp === 'SIGN_UP'"
          [isInPopup]="true"
          (changeScreen)="this.changeScreen($event)"
        ></app-sign-up-form>
        <app-forgot-password-form
          *ngIf="this.screenInPopUp === 'FORGOT_PASSWORD'"
          [isInPopup]="true"
          (changeScreen)="this.changeScreen($event)"
        ></app-forgot-password-form>
        <app-plan-required-form
          *ngIf="this.screenInPopUp === 'PLAN_REQUIRED'"
          [isInPopup]="true"
          (changeScreen)="this.changeScreen($event)"
        ></app-plan-required-form>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="this.userIsLoggedIn()"
  style="display: inline-block; position: fixed; top: 5px; right: 5px;"
>
  <button id="btnLogout" class="use-app-colors btn btn-sm btn-primary btn-block" type="button" (click)="this.logout()">
    Salir
  </button>
</div>
